import { FormDrawer, FormDrawerContent, Id } from "@dgs/core";
import { addMonths, format } from "date-fns";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { BaseApplicationDataFields } from "../../../../applications/BaseApplicationDataFields";
import { useBaseApplicationFormValidate } from "../../../../applications/baseApplicationFormValidate";
import { useCreateApplication } from "../../../../events/eventDetails/applications/create/useCreateApplication";
import { DeepApplicationConfiguration, DeepApplicationFormValues } from "../../../../shared/types/application";

interface Props {
	open: boolean;
	onClose: () => void;
	config: DeepApplicationConfiguration;
	eventId: Id;
}

export const CreateDeepApplicationDrawer: FC<Props> = ({ eventId, config, ...props }) => {
	const { t } = useTranslation();
	const { createDeepApplication } = useCreateApplication(eventId);
	const validate = useBaseApplicationFormValidate();

	const title = useMemo(() => {
		if (config.enableFrontend && !config.enableApp) {
			return t("Create DEEP");
		}
		if (!config.enableFrontend && config.enableApp) {
			return t("Create APP");
		}

		return t("Create DEEP & APP");
	}, [config.enableApp, config.enableFrontend, t]);

	const formValues: DeepApplicationFormValues = useMemo(
		() => ({
			setupDate: format(new Date(), "yyyy-MM-dd"),
			deletionDate: format(addMonths(new Date(), config.enableApp ? 3 : 2), "yyyy-MM-dd"),
			subdomain: "",
			projectNumber: "",
			event: null,
			configuration: config,
		}),
		[config],
	);

	return (
		<FormDrawer
			{...props}
			title={title}
			validate={validate}
			onSubmit={createDeepApplication}
			initialValues={formValues}
			renderForm={(props) => (
				<FormDrawerContent {...props}>
					<BaseApplicationDataFields />
				</FormDrawerContent>
			)}
		/>
	);
};
